import React from 'react';

export const handleAlertMaxItems = () => (
  <>
    <ul>
      <li>
        <span className="vads-u-display--block">
          <va-link
            href="https://www.va.gov/forms/21-686c/"
            external
            text="Get VA Form 21-686c to download"
          />
        </span>
      </li>
      <li>
        <span className="vads-u-display--block vads-u-margin-bottom--2">
          <va-link
            href="https://www.va.gov/forms/21-4138/"
            external
            text="Get VA Form 21-4138 to download"
          />
        </span>
      </li>
    </ul>
    <p>
      Both documents can be uploaded at the end of this application or sent to
      us by mail.
    </p>
  </>
);

export const handleVeteranMaxMarriagesAlert = () => (
  <div>
    <h2 className="usa-alert-heading">
      You’ve reached the maximum number of marriages
    </h2>
    <p>
      You have added the maximum number of allowed Veteran’s previous marriages
      for this application. Additional marriages can be added using 1 of these
      forms:
    </p>
    {handleAlertMaxItems()}
  </div>
);

export const handleSpouseMaxMarriagesAlert = () => (
  <div>
    <p className="vads-u-margin-top--0">
      You have added the maximum number of previous marriages allowed on this
      application. Additional marriages can be added using 1 of these forms:
    </p>
    {handleAlertMaxItems()}
  </div>
);
